import { put, takeLatest, select, takeEvery } from "@redux-saga/core/effects";
import { Notification } from "components/Notification/Noti";

import { loadRecordDataAPI } from "redux/api/objectsAPIs";
import {
  loadMappingExposeAPI,
  getConfigICAPI,
} from "redux/api/consolidatedViewSettingsAPI";

import {
  getListMessagesICAPI,
  getAllUserICAPI,
  getChatBotICAPI,
  getMessageDetailsICAPI,
  getMessageInternalDetailsICAPI,
  updateStatusICCRMAPI,
  updateStatusICAPI,
  getStatusICAPI,
  addTagICAPI,
  deleteTagICAPI,
  getTagsICAPI,
  createTagICAPI,
  disableBotICAPI,
  sendMessageICAPI,
  sendInternalMessageICAPI,
  completeConversationICAPI,
  uncompleteConversationICAPI,
  resgisterSignalrICAPI,
  registerConnectionIntervalICAPI,
  getQuickMessagesICAPI,
  getUserStateICAPI,
  addAgentICAPI,
  transferAgentICAPI,
  getIndexMessageICAPI,
  getIndexMessageInternalICAPI,
  getFacebookPostICAPI,
  getListSocialRegisterICAPI,
  getEmailDetailsICAPI,
  disconnectSignalRICAPI,
  reconnectSignalRICAPI,
  getStateListICAPI,
  getEmailSettingICAPI,
  getSocialRegisterICAPI,
  getInternalMessagesICAPI,
  addGroupICAPI,
  removeGroupMemberAPI,
  getProductListAPI,
  getLiveChatTemplateICAPI,
  updateLiveChatTemplateICAPI,
  getCustomerAPI,
  getMemberListAPI,
  getUserByIdAPI,
  leaveGroupAPI,
  getBackChatAPI,
  getButtonsIntegrationAPI,
  updateInteractionStateAPI,
  facebookLikeCommentAPI,
  facebookHideCommentAPI,
  facebookRemoveCommentAPI,
  sendMessDirectCustomerAPI,
  forwardMessageAPI,
  messageRecallAPI,
  updateMessageAPI,
  pinMessageAPI,
  unpinMessageAPI,
  getListPinMessageAPI,
} from "redux/api/icChatWidgetAPI";
import {
  getConfigIC,
  getConfigICResult,
  getAllUserIC,
  getAllUserICResult,
  getChatBotIC,
  getChatBotICResult,
  getListMessagesAssignedIC,
  getListMessagesAssignedICResult,
  getListMessagesCompletedIC,
  getListMessagesCompletedICResult,
  getMessageDetailsIC,
  getMessageDetailsICResult,
  $selectedMessage,
  $currentPageIC,
  $recordPerPageIC,
  $isActive,
  updateStatusIC,
  getStatusIC,
  getStatusICResult,
  addTagIC,
  addTagICResult,
  deleteTagIC,
  deleteTagICResult,
  getTagsIC,
  getTagsICResult,
  createTagIC,
  $addTag,
  disableBotIC,
  sendMessageIC,
  sendMessageWithFileIC,
  completeConversationIC,
  uncompleteConversationIC,
  resgisterSignalrIC,
  registerConnectionIntervalIC,
  addNewMessage,
  getQuickMessagesIC,
  getQuickMessagesICResult,
  $newMessage,
  getUserToAddIC,
  getUserToAddICResult,
  addAgentIC,
  $addAgent,
  transferAgentIC,
  $transferAgent,
  searchMessagesIC,
  searchMessagesICResult,
  getIndexMessageIC,
  getIndexMessageICResult,
  getFacebookPostIC,
  getFacebookPostICResult,
  getListSocialRegisterIC,
  getListSocialRegisterICResult,
  disconnectSignalRIC,
  reconnectSignalRIC,
  getStateListIC,
  getStateListICResult,
  getSocialPage,
  getSocialPageResult,
  getInternalMessages,
  getInternalMessagesResult,
  addNewInternalMessage,
  getInternalMessagesSearch,
  getInternalMessagesSearchResult,
  addGroupIC,
  getProductList,
  getProductListResult,
  setProductSelected,
  getLiveChatTemplate,
  getLiveChatTemplateResult,
  updateLiveChatTemplate,
  getAdvancedConfigIC,
  getAdvancedConfigICResult,
  getCustomer,
  getCustomerResult,
  // getMemberList,
  getMemberListResult,
  // getUserById,
  getUserByIdResult,
  leaveGroup,
  getBackChat,
  getButtonsIntegration,
  getButtonsIntegrationResult,
  updateInteractionState,
  facebookLikeComment,
  facebookLikeCommentResult,
  facebookHideComment,
  facebookHideCommentResult,
  facebookRemoveComment,
  facebookRemoveCommentResult,
  sendMessDirectCustomer,
  setMeta,
  setListMessagesAssignedIC,
  addGroupMember,
  removeGroupMember,
  forwardMessage,
  setMetaGroup,
  messageRecall,
  messageRecallResult,
  updateMessage,
  updateMessageResult,
  pinMessage,
  unpinMessage,
  pinMessageResult,
  unpinMessageResult,
  getListPinMessage,
  getListPinMessageResult,
} from "redux/slices/icChatWidget";
import _ from "lodash";
import moment from "moment";
export const icChatWidgetReducer = (state) => state.icChatWidgetReducer;

export default function* icIntegration() {
  yield takeLatest(getLiveChatTemplate.type, GetLiveChatTemplateIC);
  yield takeLatest(updateLiveChatTemplate.type, UpdateLiveChatTemplateIC);
  yield takeLatest(getConfigIC.type, GetConfigIC);
  yield takeLatest(getAdvancedConfigIC.type, GetAdvancedConfigIC);
  yield takeLatest(getAllUserIC.type, GetAllUserIC);
  yield takeLatest(getChatBotIC.type, GetChatBotIC);
  yield takeLatest(getListMessagesAssignedIC.type, GetListMessagesAssignedIC);
  yield takeLatest(getListMessagesCompletedIC.type, GetListMessagesCompletedIC);
  yield takeLatest(getMessageDetailsIC.type, GetMessageDetailsIC);
  yield takeLatest(updateStatusIC.type, UpdateStatusIC);
  yield takeLatest(getStatusIC.type, GetStatusIC);
  yield takeLatest(addTagIC.type, AddTagIC);
  yield takeLatest(deleteTagIC.type, DeleteTagIC);
  yield takeLatest(getTagsIC.type, GetTagsIC);
  yield takeLatest(createTagIC.type, CreateTagIC);
  yield takeLatest(disableBotIC.type, DisableBotIC);
  yield takeEvery(sendMessageIC.type, SendMessageIC);
  yield takeEvery(sendMessageWithFileIC.type, SendMessageWithFileIC);
  yield takeLatest(completeConversationIC.type, CompleteConversationIC);
  yield takeLatest(uncompleteConversationIC.type, UncompleteConversationIC);
  yield takeLatest(resgisterSignalrIC.type, ResgisterSignalrIC);
  yield takeLatest(
    registerConnectionIntervalIC.type,
    RegisterConnectionIntervalIC
  );
  yield takeLatest(getQuickMessagesIC.type, GetQuickMessagesIC);
  yield takeLatest(getUserToAddIC.type, GetUserToAddIC);
  yield takeLatest(addAgentIC.type, AddAgentIC);
  yield takeLatest(transferAgentIC.type, TransferAgentIC);
  yield takeLatest(searchMessagesIC.type, SearchMessagesIC);
  yield takeLatest(getIndexMessageIC.type, GetIndexMessageIC);
  yield takeLatest(getFacebookPostIC.type, GetFacebookPostIC);
  yield takeLatest(getListSocialRegisterIC.type, GetListSocialRegisterIC);
  yield takeLatest(disconnectSignalRIC.type, DisconnectSignalRIC);
  yield takeLatest(reconnectSignalRIC.type, ReconnectSignalRIC);
  yield takeLatest(getStateListIC.type, GetStateListIC);
  yield takeLatest(getSocialPage.type, GetSocialPage);
  yield takeLatest(getInternalMessages.type, GetInternalMessages);
  yield takeLatest(getInternalMessagesSearch.type, GetInternalMessagesSearch);
  yield takeLatest(addGroupIC.type, AddGroupIC);
  yield takeLatest(getProductList.type, GetProductList);
  yield takeLatest(getCustomer.type, GetCustomer);
  // yield takeLatest(getMemberList.type, GetMemberList);
  // yield takeLatest(getUserById.type, GetUserById);
  yield takeLatest(leaveGroup.type, LeaveGroup);
  yield takeLatest(getBackChat.type, GetBackChat);
  yield takeLatest(getButtonsIntegration.type, GetButtonsIntegration);
  yield takeLatest(updateInteractionState.type, UpdateInteractionState);
  yield takeLatest(facebookLikeComment.type, FacebookLikeComment);
  yield takeLatest(facebookHideComment.type, FacebookHideComment);
  yield takeLatest(facebookRemoveComment.type, FacebookRemoveComment);
  yield takeLatest(sendMessDirectCustomer.type, SendMessDirectCustomer);
  yield takeLatest(addGroupMember.type, AddGroupMember);
  yield takeLatest(removeGroupMember.type, RemoveGroupMember);
  yield takeLatest(forwardMessage.type, ForwardMessage);
  yield takeLatest(messageRecall.type, MessageRecall);
  yield takeLatest(updateMessage.type, UpdateMessage);
  yield takeLatest(pinMessage.type, PinMessage);
  yield takeLatest(unpinMessage.type, UnpinMessage);
  yield takeLatest(getListPinMessage.type, GetListPinMessage);
}

function* GetLiveChatTemplateIC(action) {
  try {
    const response = yield getLiveChatTemplateICAPI(action.payload);
    yield put(getLiveChatTemplateResult(_.get(response, "data.data", {})));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* UpdateLiveChatTemplateIC(action) {
  try {
    yield updateLiveChatTemplateICAPI(action.payload);
    yield put(
      getLiveChatTemplate({
        object_id: "obj_contact_00000001",
        template: "1",
      })
    );
    Notification("success", "Update successfully!");
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* GetAdvancedConfigIC(action) {
  try {
    const response = yield getConfigICAPI(action.payload);
    yield put(getAdvancedConfigICResult(_.get(response, "data.data", {})));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* GetConfigIC(action) {
  try {
    const res = yield loadMappingExposeAPI({
      object_id: action.payload.object_id,
      type: "IC",
    });
    const response = yield loadRecordDataAPI(action.payload);

    if (res.data.data !== "No record found.") {
      const fieldConfig = {
        fieldID: _.get(res, "data.data.key_field_update.value", ""),
        value:
          response.data.data?.[
            _.get(res, "data.data.key_field_update.value", "")
          ]?.value,
      };
      yield put(getConfigICResult(fieldConfig));
    }
  } catch (error) {
    // Notification("error", error.response.data.error);
  }
}

function* GetChatBotIC(action) {
  try {
    const response = yield getChatBotICAPI(action.payload);
    yield put(getChatBotICResult(_.get(response, "data.data.items", [])));
  } catch (error) {
    // Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetAllUserIC(action) {
  try {
    const response = yield getAllUserICAPI(action.payload);
    yield put(getAllUserICResult(_.get(response, "data.data.items", [])));
  } catch (error) {
    // Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetListMessagesAssignedIC(action) {
  try {
    const { selectedMessage } = yield select(icChatWidgetReducer);

    yield put($currentPageIC(1));
    const response = yield getListMessagesICAPI(action.payload);
    yield put(
      getListMessagesAssignedICResult(_.get(response, "data.data.items", []))
    );

    if (
      _.isEmpty(selectedMessage) &&
      _.get(response, "data.data.items", [])?.length > 0
    ) {
      yield put($selectedMessage(_.get(response, "data.data.items[0]", {})));
      yield put($isActive(0));
    }
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetListMessagesCompletedIC(action) {
  try {
    const { selectedMessage } = yield select(icChatWidgetReducer);

    yield put($currentPageIC(1));

    const response = yield getListMessagesICAPI(action.payload);
    yield put(
      getListMessagesCompletedICResult(_.get(response, "data.data.items", []))
    );
    if (
      _.isEmpty(selectedMessage) &&
      _.get(response, "data.data.items", [])?.length > 0
    ) {
      yield put($selectedMessage(_.get(response, "data.data.items[0]", {})));
      yield put($isActive(0));
    }
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetMessageDetailsIC(action) {
  try {
    let response;
    if (_.get(action, "payload.is_group", false)) {
      response = yield getMessageInternalDetailsICAPI({
        ...action.payload,
        is_all: undefined,
        page_social_id: undefined,
        user_social_id: undefined,
        post_id: undefined,
        is_group: undefined,
        channel_type: undefined,
        is_group_or_agent: undefined,
        tenant_id: undefined,
        username: undefined,
      });

      yield put(
        getListPinMessage({
          interaction_id: _.get(action, "payload.interaction_id", ""),
          page: 0,
          limit: 0,
          is_banner: false,
        })
      );

      if (_.get(action, "payload.is_group_or_agent", false)) {
        const responseMemberList = yield getMemberListAPI({
          interaction_id: _.get(action, "payload.interaction_id", ""),
          tenant_id: _.get(action, "payload.tenant_id", ""),
        });
        yield put(
          getMemberListResult(_.get(responseMemberList, "data.data", []))
        );
      } else {
        const responseUserById = yield getUserByIdAPI({
          item: _.get(action, "payload.username", ""),
        });
        yield put(getUserByIdResult(_.get(responseUserById, "data.data", {})));
      }
    } else {
      response = yield getMessageDetailsICAPI({
        ...action.payload,
        post_id: undefined,
        is_group: undefined,
        is_group_or_agent: undefined,
        tenant_id: undefined,
        username: undefined,
      });
    }

    if (_.get(action, "payload.channel_type", "") === "email") {
      let emailIds = [];
      let logsIndex = [];
      _.map(_.get(response, "data.data.items", [])?.reverse(), (item, idx) => {
        if (_.get(item, "message_id", "")) {
          emailIds.push({
            id: _.get(item, "message_id", ""),
          });
        } else {
          logsIndex.push(idx);
        }
      });
      const responseEmail = yield getEmailDetailsICAPI(emailIds);
      let result = [..._.get(responseEmail, "data.data.items", [])];
      _.map(logsIndex, (index) => {
        result.splice(index, 0, response?.data?.data?.items[index] || {});
      });
      yield put(
        getMessageDetailsICResult({
          data: result,
          page: _.get(action, "payload.page", 1),
          channel_type: _.get(action, "payload.channel_type", ""),
        })
      );
      yield put(getIndexMessageICResult(null));
    } else {
      yield put(
        getMessageDetailsICResult({
          data: _.get(response, "data.data.items", []),
          page: _.get(action, "payload.page", 1),
          channel_type: _.get(action, "payload.channel_type", ""),
        })
      );
      yield put(getIndexMessageICResult(null));

      if (
        _.get(action, "payload.channel_type", "") === "facebook_comment" ||
        _.get(action, "payload.channel_type", "") === "instagram_comment"
      ) {
        yield put(
          getFacebookPostIC({
            page_social_id: _.get(action, "payload.page_social_id", ""),
            post_id: _.get(action, "payload.post_id", ""),
          })
        );
      } else {
        yield put(getFacebookPostICResult({}));
      }
    }
  } catch (error) {
    yield put(getMessageDetailsICResult([]));
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* UpdateStatusIC(action) {
  try {
    yield updateStatusICCRMAPI({
      ic_status: _.get(action, "payload.ic_status", ""),
    });
    yield updateStatusICAPI({
      state_detail: _.get(action, "payload.ic_status", ""),
      username: _.get(action, "payload.username", ""),
    });
    yield put(
      getStatusIC({
        username: _.get(action, "payload.username", ""),
      })
    );
    Notification("success", "Change status successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetStatusIC(action) {
  try {
    const response = yield getStatusICAPI(action.payload);
    yield put(getStatusICResult(_.get(response, "data.data.state_id", "")));
  } catch (error) {
    // Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* AddTagIC(action) {
  try {
    const response = yield addTagICAPI(action.payload);
    yield put(
      addTagICResult({
        ..._.get(response, "data.data", {}),
        interaction_id: _.get(action, "payload.interaction_id", ""),
        interactiondetail_id: _.get(action, "payload.interactiondetail_id", ""),
      })
    );
    yield put(
      $addTag({
        visible: false,
        interaction_id: "",
        interactiondetail_id: "",
      })
    );
    Notification("success", "Add tag successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* DeleteTagIC(action) {
  try {
    yield deleteTagICAPI(action.payload);
    yield put(deleteTagICResult(action.payload));
    Notification("success", "Delete tag successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* CreateTagIC(action) {
  try {
    yield createTagICAPI(action.payload);
    yield put(getTagsIC({}));
    Notification("success", "Create tag successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetTagsIC(action) {
  try {
    const response = yield getTagsICAPI(action.payload);

    let result = [];
    _.map(_.get(response, "data.data.items", []), (item) => {
      result.push({
        label: _.get(item, "name", ""),
        value: _.get(item, "id", ""),
      });
    });
    yield put(getTagsICResult(result));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* DisableBotIC(action) {
  try {
    const response = yield disableBotICAPI({
      interaction_id: action.payload.interaction_id,
    });

    const { assignedMessages, completedMessages } = yield select(
      icChatWidgetReducer
    );
    let temp = [...assignedMessages];
    if (action.payload?.isCompleted) {
      temp = [...completedMessages];
    }

    const findIndex = temp.findIndex(
      (item) =>
        _.get(item, "interaction_id", "") === action.payload.interaction_id
    );
    if (findIndex !== -1) {
      temp[findIndex] = {
        ...temp[findIndex],
        is_botprogress: false,
      };
      yield put($selectedMessage(temp[findIndex]));
    }

    if (action.payload?.isCompleted) {
      yield put(getListMessagesCompletedICResult(temp));
    } else {
      yield put(getListMessagesAssignedICResult(temp));
    }

    yield put(
      $newMessage({
        ..._.get(response, "data.data", {}),
        is_botprogress: false,
      })
    );
    Notification("success", "Disable bot successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* SendMessageIC(action) {
  try {
    let response;

    if (_.get(action, "payload.is_group", false)) {
      response = yield sendInternalMessageICAPI({
        ...action.payload,
        is_group: undefined,
        interaction_id:
          action.payload.interaction_id === "new_interaction_3484597322"
            ? null
            : action.payload.interaction_id,
      });
    } else {
      response = yield sendMessageICAPI({
        ...action.payload,
        is_group: undefined,
      });
    }

    if (_.get(action, "payload.channel_type") === "email") {
      let newMessage = {
        server_email_type: _.get(action, "payload.data_mail.server_email_type"),
        attachments: _.get(action, "payload.data_mail.attachments"),
        direction: "send",
        subject: _.get(action, "payload.data_mail.subject"),
        from: _.get(action, "payload.data_mail.from_mail"),
        to: _.get(action, "payload.to", [])?.toString(),
        list_cc: _.get(action, "payload.cc", [])?.toString(),
        list_bcc: null,
        reply_to: _.get(action, "payload.data_mail.message_id", ""),
        reply_message_id: null,
        emaildata_warning: null,
        modify_by: null,
        content: _.get(action, "payload.data_mail.content", ""),
        state: "sent",
        create_by: _.get(response, "data.data.create_by", ""),
        create_time: _.get(response, "data.data.create_time", ""),
        modify_time: _.get(response, "data.data.modify_time", ""),
        //unused?
        email_box_id: "",
        thread_id: "",
        message_id: "",
        id: _.get(response, "data.data.id", ""),
        tenant_id: _.get(response, "data.data.tenant_id", ""),
      };

      yield put(addNewMessage(newMessage));
    } else {
      yield put(addNewMessage(_.get(response, "data.data"), {}));
    }
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* SendMessageWithFileIC(action) {
  try {
    for (const i in action.payload) {
      if (action.payload.hasOwnProperty(i)) {
        let response;
        if (action.payload[i]?.is_group) {
          response = yield sendInternalMessageICAPI({
            ...action.payload[i],
            is_group: undefined,
            interaction_id:
              action.payload[i].interaction_id === "new_interaction_3484597322"
                ? null
                : action.payload[i].interaction_id,
          });
        } else {
          response = yield sendMessageICAPI({
            ...action.payload[i],
            is_group: undefined,
          });
        }

        yield put(addNewMessage(_.get(response, "data.data"), {}));
      }
    }
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* ResgisterSignalrIC(action) {
  try {
    yield resgisterSignalrICAPI(action.payload);
    yield put(
      getStatusIC({
        username: _.get(action, "payload.username", ""),
      })
    );
  } catch (error) {
    // Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* RegisterConnectionIntervalIC(action) {
  try {
    yield registerConnectionIntervalICAPI(action.payload);
  } catch (error) {}
}

function* CompleteConversationIC(action) {
  try {
    const { configIC, filter, meta } = yield select(icChatWidgetReducer);
    yield completeConversationICAPI({
      list_interaction_id: action.payload.list_interaction_id,
    });
    yield put($selectedMessage({}));
    yield put($isActive(0));
    yield put(
      getListMessagesAssignedIC({
        extention: "assigned",
        limit: action.payload.type === "ICChat" ? meta.limit : 1000,
        page: action.payload.type === "ICChat" ? meta.page : 1,
        view_type: "",
        search_list:
          action.payload.type === "ICChat"
            ? [...filter.search_list]
            : [
                {
                  name_field: "customer_id",
                  value_search: _.get(configIC, "value", ""),
                },
              ],
      })
    );

    Notification("success", "Complete conversation successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* UncompleteConversationIC(action) {
  try {
    const { configIC, filter, meta } = yield select(icChatWidgetReducer);
    yield uncompleteConversationICAPI({
      interaction_id: action.payload.interaction_id,
    });
    yield put($selectedMessage({}));
    yield put($isActive(0));
    yield put(
      getListMessagesCompletedIC({
        extention: "complete",
        limit: action.payload.type === "ICChat" ? meta.limit : 1000,
        page: action.payload.type === "ICChat" ? meta.page : 1,
        view_type: "",
        search_list:
          action.payload.type === "ICChat"
            ? [...filter.search_list]
            : [
                {
                  name_field: "customer_id",
                  value_search: _.get(configIC, "value", ""),
                },
              ],
      })
    );
    Notification("success", "Uncomplete conversation successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetQuickMessagesIC(action) {
  try {
    const response = yield getQuickMessagesICAPI(action.payload);
    yield put(getQuickMessagesICResult(_.get(response, "data.data.items", [])));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetUserToAddIC(action) {
  try {
    const response1 = yield getUserStateICAPI({
      search_list: [
        {
          name_field: "state",
          value_search: "online",
        },
      ],
    });
    // const response2 = yield getInteractionMemberICAPI({
    //   interaction_id: _.get(action, "payload.interaction_id", ""),
    //   tenant_id: localStorage.getItem("icIntegration_tenantID"),
    // });

    // let temp = [];

    // if (_.get(action, "payload.type") === "transfer") {
    //   temp = _.get(response1, "data.data.items", [])?.filter((el) => {
    //     return !_.get(response2, "data.data.items", []).find((element) => {
    //       return element?.username === el?.username && element?.is_owner;
    //     });
    //   });
    // } else {
    //   temp = _.get(response1, "data.data.items", [])?.filter((el) => {
    //     return !_.get(response2, "data.data.items", []).find((element) => {
    //       return element?.username === el?.username;
    //     });
    //   });
    // }

    let result = [];
    _.map(_.get(response1, "data.data.items", []), (item, idx) => {
      result.push({
        label:
          _.get(item, "fullname", "") + " - " + _.get(item, "username", ""),
        value: _.get(item, "username", idx),
      });
    });

    yield put(getUserToAddICResult(result));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* AddAgentIC(action) {
  try {
    yield put(
      $addAgent({
        isLoading: true,
        visible: true,
        ...action.payload,
      })
    );
    const response = yield addAgentICAPI(action.payload);
    yield put(addNewMessage(_.get(response, "data.data"), {}));
    yield put(
      $addAgent({
        isLoading: false,
        visible: false,
        interaction_id: "",
        note_content: "",
        username_dest: "",
        username_source: "",
      })
    );
    Notification("success", "Your request is saved!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
    yield put(
      $addAgent({
        isLoading: false,
        visible: false,
        interaction_id: "",
        note_content: "",
        username_dest: "",
        username_source: "",
      })
    );
  }
}

function* TransferAgentIC(action) {
  try {
    yield put(
      $transferAgent({
        isLoading: true,
        visible: true,
        ...action.payload,
        type: undefined,
      })
    );
    yield transferAgentICAPI({
      ...action.payload,
      type: undefined,
    });

    yield put($selectedMessage({}));
    yield put($isActive(0));

    const { configIC, filter, meta } = yield select(icChatWidgetReducer);

    yield put(
      getListMessagesAssignedIC({
        extention: "assigned",
        limit: action.payload.type === "ICChat" ? meta.limit : 1000,
        page: action.payload.type === "ICChat" ? meta.page : 1,
        view_type: "",
        search_list:
          action.payload.type === "ICChat"
            ? [...filter.search_list]
            : [
                {
                  name_field: "customer_id",
                  value_search: _.get(configIC, "value", ""),
                },
              ],
      })
    );

    yield put(
      $transferAgent({
        isLoading: false,
        visible: false,
        interaction_id: "",
        note_content: "",
        username_dest: "",
        username_source: "",
      })
    );
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
    yield put(
      $transferAgent({
        isLoading: false,
        visible: false,
        interaction_id: "",
        note_content: "",
        username_dest: "",
        username_source: "",
      })
    );
  }
}

function* SearchMessagesIC(action) {
  try {
    let response;
    if (_.get(action, "payload.isGroup")) {
      response = yield getMessageInternalDetailsICAPI({
        interaction_id: _.get(action, "payload.interaction_id", ""),
        search_text: _.get(action, "payload.search_text", ""),
      });
    } else {
      response = yield getMessageDetailsICAPI({
        ...action.payload,
        isGroup: undefined,
      });
    }

    yield put(searchMessagesICResult(_.get(response, "data.data.items", [])));
  } catch (error) {
    yield put(searchMessagesICResult([]));
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetIndexMessageIC(action) {
  try {
    let response;
    if (_.get(action, "payload.isGroup")) {
      response = yield getIndexMessageInternalICAPI({
        ...action.payload,
        isGroup: undefined,
      });
    } else {
      response = yield getIndexMessageICAPI({
        ...action.payload,
        isGroup: undefined,
      });
    }

    yield put(
      getIndexMessageICResult(_.get(response, "data.data.index", null))
    );
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetFacebookPostIC(action) {
  try {
    const response = yield getFacebookPostICAPI(action.payload);
    yield put(getFacebookPostICResult(_.get(response, "data.data", {})));
  } catch (error) {
    yield put(getFacebookPostICResult({}));
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetListSocialRegisterIC(action) {
  try {
    const response = yield getListSocialRegisterICAPI(action.payload);
    yield put(
      getListSocialRegisterICResult(_.get(response, "data.data.items", []))
    );
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* DisconnectSignalRIC(action) {
  try {
    yield disconnectSignalRICAPI(action.payload);
    localStorage.removeItem("icIntegration_connection_ids");
    localStorage.removeItem("icIntegration_link_api");
    localStorage.removeItem("icIntegration_accessToken");
  } catch (error) {}
}

function* ReconnectSignalRIC(action) {
  try {
    yield reconnectSignalRICAPI(action.payload);
  } catch (error) {}
}

function* GetStateListIC(action) {
  try {
    const response = yield getStateListICAPI(action.payload);
    yield put(getStateListICResult(_.get(response, "data.data.items", [])));
  } catch (error) {
    // Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetSocialPage(action) {
  try {
    const response = yield getEmailSettingICAPI(action.payload);
    const response2 = yield getSocialRegisterICAPI(action.payload);

    const result = [];
    _.forEach(_.get(response, "data.data.items", []), (item) => {
      result.push({
        label: item.email,
        value: item.email,
        channel_type: "email",
      });
    });

    _.forEach(_.get(response2, "data.data.items", []), (item) => {
      result.push({
        label: item.social_name,
        value: item.social_id,
        channel_type: item.channel_type,
      });
    });

    yield put(getSocialPageResult(result));
  } catch (error) {
    // Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetInternalMessages(action) {
  try {
    const { selectedMessage } = yield select(icChatWidgetReducer);

    const response = yield getInternalMessagesICAPI({
      ...action.payload,
      is_get_back: undefined,
    });

    yield put(
      getInternalMessagesResult({
        data: _.get(response, "data.data.items", []),
        is_get_back: _.get(action, "payload.is_get_back", ""),
      })
    );
    if (
      _.isEmpty(selectedMessage) &&
      _.get(response, "data.data.items", [])?.length > 0
    ) {
      yield put($selectedMessage(_.get(response, "data.data.items[0]", {})));
    }
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetInternalMessagesSearch(action) {
  try {
    const response = yield getInternalMessagesICAPI(action.payload);
    yield put(
      getInternalMessagesSearchResult(_.get(response, "data.data.items", []))
    );
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* AddGroupIC(action) {
  try {
    const { metaGroup } = yield select(icChatWidgetReducer);
    yield addGroupICAPI(action.payload);
    yield put($isActive(0));
    yield put($selectedMessage({}));
    yield put(
      getInternalMessages({
        limit: metaGroup.limit || 20,
        page: metaGroup.page || 1,
        search_list: [],
      })
    );
    Notification("success", "Add group successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetProductList(action) {
  try {
    const { productListMeta } = yield select(icChatWidgetReducer);

    const response = yield getProductListAPI(action.payload);
    yield put(
      getProductListResult({
        data: response.data.data.items,
        page: productListMeta.page,
      })
    );
    if (productListMeta.page === 1) {
      yield put(setProductSelected(_.get(response, "data.data.items[0]", {})));
    }
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetCustomer(action) {
  try {
    const response = yield getCustomerAPI(action.payload);
    yield put(getCustomerResult(response.data.data));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* LeaveGroup(action) {
  try {
    const { metaGroup } = yield select(icChatWidgetReducer);
    yield leaveGroupAPI(action.payload);
    yield put($isActive(0));
    yield put($selectedMessage({}));
    yield put(
      getInternalMessages({
        limit: metaGroup.limit || 20,
        page: metaGroup.page || 1,
        search_list: [],
      })
    );
    Notification("success", "Leave group successfully!");
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetBackChat(action) {
  try {
    const response = yield getBackChatAPI(action.payload);
    if (_.get(response, "data.data.interaction_id")) {
      yield put(
        getInternalMessages({
          limit: 20,
          page: 1,
          search_list: [],
          is_get_back: response.data.data.interaction_id,
        })
      );
    } else {
      const newMessage = {
        username: action.payload.username_backchat,
        interactiondetail_id: "00000000-0000-0000-0000-000000000000",
        interaction_id: "new_interaction_3484597322",
        content_text: "",
        create_time: moment(),

        // "user_fullname": null,
        // "interaction_state": "received",
        // "is_owner": false,
        // "group_name": null,
        // "is_group": false,
        // "sender_type": "agent",
        // "content_text": "hi",
        // "content_file_url": "",
        // "content_file_type": "",
        // "content_file_name": null,
        // "interaction_type": "text",
        // "content_download_url": null,
        // "is_active_message": null,
        // "is_botprogress": false,
        // "owner_username": null,
        // "complete_by": null,
        // "ticket_id": null,
        // "is_hidden_message": null,
        // "interactionTags": null,
        // "list_content_test": null,
        // "customer_id": "00000000-0000-0000-0000-000000000000",
        // "user_social_id": null,
        // "page_social_id": null,
        // "channel_type": null,
        // "state": "assigned",
        // "app_id": null,
        // "device_type": null,
        // "device_ip": null,
        // "location_long": null,
        // "location_lat": null,
        // "source_address": null,
        // "is_active": true,
        // "post_id": null,
        // "topic": null,
        // "avatar": null,
        // "customer_name": null,
        // "possession_mode": null,
        // "is_waiting_approve": false,
        // "fpt_channel_type": null,
        // "is_createby_chatbot": false,
        // "customfields": null,
        // "id": "00000000-0000-0000-0000-000000000000",
        // "tenant_id": "a69c7dd0-a50a-4d29-965f-955811a62b0f",
        // "create_by": "agent2.servicedesk@yopmail.com",
        // "modify_by": null,
        // "modify_time": "0001-01-01T00:00:00"
      };
      yield put(addNewInternalMessage(newMessage));

      yield put(
        getMessageDetailsICResult({
          data: [],
          page: 1,
        })
      );
      yield put($isActive(0));
      yield put($currentPageIC(1));
      yield put($recordPerPageIC(null));
      yield put(getIndexMessageICResult(null));
      yield put(searchMessagesICResult([]));
      yield put($selectedMessage(newMessage));
    }
  } catch (error) {}
}

function* GetButtonsIntegration(action) {
  try {
    const response = yield getButtonsIntegrationAPI(action.payload);
    yield put(
      getButtonsIntegrationResult(_.get(response, "data.data.items", []))
    );
  } catch (error) {}
}

function* UpdateInteractionState(action) {
  try {
    yield updateInteractionStateAPI(action.payload);
  } catch (error) {}
}

function* FacebookLikeComment(action) {
  try {
    yield facebookLikeCommentAPI(action.payload);
    yield put(
      facebookLikeCommentResult({
        interactiondetail_id: _.get(action, "payload.interactiondetail_id"),
      })
    );
  } catch (error) {}
}

function* FacebookHideComment(action) {
  try {
    yield facebookHideCommentAPI(action.payload);
    yield put(
      facebookHideCommentResult({
        interaction_detail_id: _.get(action, "payload.interaction_detail_id"),
        parent_message: _.get(action, "payload.parent_message"),
        comment_state: _.get(action, "payload.comment_state"),
      })
    );
  } catch (error) {}
}

function* FacebookRemoveComment(action) {
  try {
    yield facebookRemoveCommentAPI(action.payload);
    yield put(
      facebookRemoveCommentResult({
        interaction_detail_id: _.get(action, "payload.interaction_detail_id"),
        parent_message: _.get(action, "payload.parent_message"),
        comment_state: _.get(action, "payload.comment_state"),
      })
    );
  } catch (error) {}
}

function* SendMessDirectCustomer(action) {
  try {
    yield sendMessDirectCustomerAPI(action.payload);
    yield put(
      setListMessagesAssignedIC({
        data: [],
        type: "reset",
      })
    );
    yield put($selectedMessage({}));
    yield put($isActive(0));

    yield put(
      setMeta({
        limit: 20,
        page: 1,
        hasMore: true,
      })
    );
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* AddGroupMember(action) {
  try {
    yield addGroupICAPI({
      ...action.payload,
      tenant_id: undefined,
    });
    const responseMemberList = yield getMemberListAPI({
      interaction_id: _.get(action, "payload.interaction_id", ""),
      tenant_id: _.get(action, "payload.tenant_id", ""),
    });
    yield put(getMemberListResult(_.get(responseMemberList, "data.data", [])));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* RemoveGroupMember(action) {
  try {
    yield removeGroupMemberAPI({
      ...action.payload,
      tenant_id: undefined,
    });
    const responseMemberList = yield getMemberListAPI({
      interaction_id: _.get(action, "payload.interaction_id", ""),
      tenant_id: _.get(action, "payload.tenant_id", ""),
    });
    yield put(getMemberListResult(_.get(responseMemberList, "data.data", [])));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* ForwardMessage(action) {
  try {
    yield forwardMessageAPI(action.payload);
    yield put(
      setMetaGroup({
        limit: 20,
        page: 1,
        hasMore: true,
      })
    );
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* MessageRecall(action) {
  try {
    yield messageRecallAPI(action.payload);
    yield put(messageRecallResult(action.payload));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* UpdateMessage(action) {
  try {
    yield updateMessageAPI(action.payload);
    yield put(updateMessageResult(action.payload));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* PinMessage(action) {
  try {
    yield pinMessageAPI(action.payload);
    yield put(pinMessageResult(action.payload));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* UnpinMessage(action) {
  try {
    yield unpinMessageAPI(action.payload);
    yield put(unpinMessageResult(action.payload));
  } catch (error) {
    Notification("error", _.get(error, "response.data.message", "Error!"));
  }
}

function* GetListPinMessage(action) {
  try {
    const response = yield getListPinMessageAPI(action.payload);
    yield put(getListPinMessageResult(_.get(response, "data.data.items", [])));
  } catch (error) {}
}
